module.exports = __webpack_public_path__ + "img/sight_icon.594b9b1b.png";